import { ApiChallengeShow } from '~/api/v1/challenges/[id]/get-type';
import { Button } from '~/components/Button/Button';
import { CardProjectDetail } from '~/components/Card/CardProjectDetail';

const Card = ({ challenge }: { challenge: ApiChallengeShow }) => {
  const ownerName = challenge.owner_corporate?.name || challenge.owner_organization?.name || '';

  return (
    <CardProjectDetail
      link={`/challenges/${challenge.id}`}
      areaText={challenge.area}
      categoryList={challenge.social_issues.map((s) => s.name)}
      companyName={ownerName}
      text={challenge.description}
      title={challenge.title}
      src={challenge.image}
      label={'チャレマ'}
      status={'募集中'}
      recruitmentList={challenge.needs.map((n) => n.name)}
      index={{
        label: challenge.challenge_impact.label,
        value: Number(challenge.challenge_impact.value),
        unit: challenge.challenge_impact.unit,
      }}
    />
  );
};

type Props = {
  challenges: ApiChallengeShow[];
};

export const Projects = ({ challenges }: Props) => {
  return (
    <div className='flex flex-col items-center gap-16 p-16'>
      <p className='text-title-strong-medium__sp text-accent lg:text-title-strong-medium'>
        プロジェクト
      </p>
      <div className='flex flex-row flex-wrap justify-center gap-4'>
        {challenges.map((c, i) => (
          <Card key={i} challenge={c} />
        ))}
      </div>
      <Button variant={'basic'} isShowArrowIcon link={{ href: '/challenges/intilaq' }}>
        もっと見る
      </Button>
    </div>
  );
};
